import React from 'react';
import LoginButton from './LoginButton';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="logo-section">
            <img 
              src="/SSI_logo_white.png" 
              alt="SSI Strategy" 
              className="logo-image"
            />
            <h1>Profiler</h1>
          </div>
          <p className="login-subtitle">
            AI Enabled Professional Profile Management
          </p>
        </div>

        <div className="login-content">
          <div className="welcome-message">
            <h2>Welcome</h2>
            <p>
              Sign in with your SSI Strategy account to access the Profiler application.
            </p>
          </div>

          <div className="login-form">
            <LoginButton className="login-primary" />
            
            <div className="login-info">
              <p>
                <small>
                  Only users with @ssistrategy.com accounts can access this application.
                </small>
              </p>
            </div>
          </div>
        </div>

        <div className="login-footer">
          <p>
            <small>
              SSI Strategy • Innovation Office
            </small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;